<!--component html goes here -->
cell visit dashbaord